jQuery(function(){

    jQuery('.rewards-form__form').submit(function(e){
        e.preventDefault();

        var $form = jQuery(this);
        $form.find('.rewards-form__column').addClass('rewards-form__column--hidden');
        $form.find('.rewards-form__column--success').removeClass('rewards-form__column--hidden');

        return false;
    });

});